import type { PublicSiteLocaleOverride } from '../publicSiteTypes'

export const hiPublicSiteOverride = {
  content: {
    brand: {
      tagline: 'ऐसी योजनाएं जो सच में चलती रहें',
    },
    routes: [
      { label: 'ओवरव्यू', title: 'The Timelining App', description: 'क्रेडिट अर्थव्यवस्था, AI समीक्षा और योजनाओं को जीवंत रखने वाले RPG लूप के साथ विजुअल प्लानिंग वर्कस्पेस।' },
      { label: 'समाधान', title: 'समाधान', description: 'वास्तविक workflow: launches, agencies, creators, students, field ops और cohorts।' },
      { label: 'गाइड', title: 'गाइड', description: 'खाली workspace से shipped plan तक की पूरी guide, हर surface, role और ceremony के साथ।' },
      { label: 'संसाधन', title: 'संसाधन', description: 'कॉपी करने योग्य patterns, AI prompt library, checklist templates और cadences।' },
      { label: 'कीमत', title: 'कीमत', description: 'Credit-economy pricing. Seats नहीं, actual burn के लिए pay करें।' },
      { label: 'डाउनलोड', title: 'डाउनलोड', description: 'Public download surface से Android Member और Helper apps install करें।' },
      { label: 'हमारे बारे में', title: 'हमारे बारे में', description: 'यह app क्यों है, क्या shipped है, और आगे क्या आ रहा है।' },
      { label: 'FAQ', title: 'FAQ', description: 'Setup, AI, gamification, teams और data पर 25 जवाब।' },
      { label: 'संपर्क', title: 'संपर्क', description: 'Pilots, support, feedback, walkthroughs और press के लिए संपर्क करें।' },
    ],
    hero: {
      eyebrow: 'Visual planning · credit economy · AI review',
      headline: 'ऐसी योजनाएं जो सच में चलती रहें',
      accent: 'चलती रहें',
      primaryCtaSignedOut: 'ऐप शुरू करें',
      primaryCtaSignedIn: 'मेरा workspace खोलें',
      secondaryCta: 'गाइड पढ़ें',
      consoleNoteSignedOut: 'Sign in private app experience में खुलता है।',
      consoleNoteSignedIn: 'आप signed in हैं। अपने current workspace से जारी रखें।',
    },
    ctaBand: {
      eyebrow: 'तैयार?',
      title: 'Console खोलें। या app लें।',
      primary: 'Console खोलें',
      secondary: 'APK लें',
    },
  },
  chrome: {
    nav: {
      ariaLabel: 'Public navigation',
      brandHomeSuffix: 'home',
      contact: 'संपर्क',
      getStarted: 'शुरू करें',
      languageLabel: 'भाषा',
      languageAriaLabel: 'Website language',
    },
    common: {
      openWorkspace: 'मेरा workspace खोलें',
      openConsole: 'Console खोलें',
      featureColumnHeader: 'फ़ीचर',
      capabilityColumnHeader: 'क्षमता',
    },
    download: {
      eyebrow: 'Timelining लें',
      title: 'Android apps install करें।',
      downloadApk: 'APK डाउनलोड',
      copyLink: 'Link copy करें',
      share: 'Share',
    },
  },
} satisfies PublicSiteLocaleOverride
